<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('commands')">Command</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create 
    </h1>
    <preview :preview_message=form.command_reply />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.command_name" class="pr-6 pb-8 w-full" label="Command Name" :error="this.$page.props.errors.command_name"/>
          <textarea-input v-model="form.command_reply" class="pr-6 pb-8 w-full" label="Command Reply" rows="4" max-rows="6" :error="this.$page.props.errors.command_reply"/>
          <!--
          <text-input v-model="form.stream_title_hashtag" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Title Hashtags" />
          <text-input v-model="form.stream_tags" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Hash Tags" />
          <text-input v-model="form.stream_game" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Game" />
          -->
          <select-input v-model="form.mention_user" class="pr-6 pb-8 w-full lg:w-1/2" label="Mention User">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
          <select-input v-model="form.is_enabled" class="pr-6 pb-8 w-full lg:w-1/2" label="Is Enabled">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Command</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '../../Shared/TextareaInput.vue'
import Preview from '../../Shared/Preview.vue'

export default {
  metaInfo: { title: 'Create Command' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    Preview,
  },
  layout: Layout,
  remember: 'form',

  data() {
    return {
      form: this.$inertia.form({
        command_name: null,
        command_reply: null,
        mention_user: 1,
        stream_title_hashtag: null,
        stream_tags: null,
        stream_game: null,
        is_enabled: 1,
      })
     };
  },
  methods: {
    store() {
      this.form.post(this.route('commands.store'))
    },
    update() {
      this.form.put(this.route('commands.update', this.commands.id))
    },
  },
}
</script>
